import {
  RemissionAsset,
  RemissionAssetUi,
} from '@/components/Order/OrderDetails/DeliveryEvidence/Remission/RemissionUi';
import { DeliveryRegistrationFormUi } from '@/components/Order/OrderDetails/DeliveryRegistrationForm/DeliveryRegistrationFormUi';
import { OrderDeliveryInfoResponse } from '@/data/api/model/orders/detailOrdersDeliveryInfoDto';
import dayjs from 'dayjs';

export function OrderDeliveryInfoResponseToDeliveryRegistrationFormUi(
  input: OrderDeliveryInfoResponse
): DeliveryRegistrationFormUi {
  return {
    orderNumber: input.order_details_delivery_id,
    deliveryTotalAmount:
      input.final_total_order_detail_amount?.toString() ?? '',
    deliveryConfirmedDate: input.final_delivery_date
      ? dayjs(input.final_delivery_date)
      : null,
    deliveryConfirmedTime: input.final_delivery_time
      ? dayjs(input.final_delivery_time, 'HH:mm')
      : null,
    deliveryConfirmedNotes: input.final_delivery_notes ?? '',
    appliedMercantoWarranty: input.warranty_applied,
    saveDisabled: true,
    cancelDisabled: true,
    deliveryOrderExtraProducts: input.includes_extra_products,
    deliveryProductPriceAdjusted: input.adjusted_product_prices,
    deliveryOrderCompleted: input.all_products_completed,
  };
}

export function OrderDeliveryInfoResponseToRemissionUi(
  input: OrderDeliveryInfoResponse
): RemissionAssetUi {
  const url = input.delivery_proof_images?.[0];
  let asset: RemissionAsset | undefined;
  if (url) {
    asset = url.toLowerCase().endsWith('.pdf')
      ? ({ kind: 'pdfSavedAsset', url } as const)
      : ({ kind: 'imageSavedAsset', url } as const);
  }
  return { asset, cancelDisabled: true, saveDisabled: true };
}
